import React, { createContext, useState } from 'react';

interface BuilderComponentOpenContextType {
  componentEditorOpen: string | undefined;
  setComponentEditorOpen: (componentEditorOpen: string | undefined) => void;
}

export const BuilderComponentOpenContext = createContext<BuilderComponentOpenContextType>({
  componentEditorOpen: undefined,
  setComponentEditorOpen: () => {},
});

export function BuilderComponentOpenProvider({ children }) {
  const [componentEditorOpen, setComponentEditorOpen] = useState<string>();

  return (
    <BuilderComponentOpenContext.Provider value={{ componentEditorOpen, setComponentEditorOpen }}>
      {children}
    </BuilderComponentOpenContext.Provider>
  );
}
